export default __webpack_public_path__ + "static/media/micro-payments.35c1b3b5.svg";